import type { JSX } from 'react';
import { useI18n } from '../../i18n';

/** AU-8 (mockup `.aimark`): «Tia added» / «Tia changed» on a thing the AI made or changed, until the GM has opened it. */
export type AiMarkKind = 'added' | 'changed';

export function AiMark({ kind }: { readonly kind: AiMarkKind }): JSX.Element {
  const { t } = useI18n();
  return (
    <span
      className="flex-none whitespace-nowrap rounded-full border border-ai/45 px-1.5 text-label text-ai"
      data-testid="ai-mark"
      data-mark={kind}
    >
      {t(kind === 'added' ? 'aiMark.added' : 'aiMark.changed')}
    </span>
  );
}

/** The lit row of a marked thing (mockup `.ai-new`). */
export const AI_NEW = 'ring-1 ring-inset ring-ai/55 bg-ai/10';
